import ICategoryUI from "./ICategoryUI";
import INewSupplier from "./INewSupplier";
import { VIRTUAL_CATEGORIES, VirtualCategoryGuidEnum } from "./VirtualCategories";

// Display names live here (not in VirtualCategories.ts) because that file is
// regenerated on model sync from the API.
export const getVirtualCategoryDisplayName = (guid: VirtualCategoryGuidEnum): string => {
    switch (guid) {
        case VirtualCategoryGuidEnum.NEW_RELEASES:
            return "New Releases";
        case VirtualCategoryGuidEnum.READY_TO_SHIP:
            return "Ready To Ship";
    }
};

/**
 * Builds the synthetic root-category entries for every virtual category the
 * supplier has enabled, ready to be unshifted ahead of the real categories.
 */
export const buildVirtualRootCategories = (supplierModel: INewSupplier): ICategoryUI[] => {
    return Object.values(VIRTUAL_CATEGORIES)
        .filter((virtualCategory) => !!supplierModel[virtualCategory.supplierGate])
        .map((virtualCategory) => {
            return {
                guid: virtualCategory.guid,
                id: virtualCategory.sentinelId,
                isOpen: false,
                name: getVirtualCategoryDisplayName(virtualCategory.guid),
                created_at: "",
                updated_at: "",
            } as ICategoryUI;
        });
};
